import { HubSettingType } from '../../../enums/social-network/hub-setting-type.enum';

export class HubSettings {
  public hubId: number;
  public type: HubSettingType;
  public value: string;
}
